import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Badge, Button, TextStyle } from '@superops/ui-design-system';
import { TITLE_MAP } from '@nile/components/src/Constants/pricing';

const PlanItemContainerWrapper = styled.div`
  .detail-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1;
  }

  .desc {
    font-size: 12px;
  }
  .italic {
    font-style: italic;
  }
  .Polaris-TextField {
    width: 50px;
    border: 1px solid #92979b;
  }
  .sp-arnd {
    justify-content: space-around;
  }
  .addLink {
    cursor: pointer;
    color: #011fff;
  }
  .plan-type {
    width: 30%;
  }
  .plan-inp {
    width: 15%;
    &.opacity {
      opacity: 50%;
    }
  }
  .plan-calc {
    width: 15%;
    text-align: center;
  }
  .plan-total {
    width: 15%;
    text-align: end;
  }
  .plan-total-desc {
    width: 25%;
    text-align: left;
    padding-left: 20px;
  }
  .number-holder {
    border: 1px solid #dadada;
    border-radius: 4px;
    display: flex;
    justify-content: space-around;
    padding: 4px;
    align-items: center;
    line-height: 1;
    .action-btn {
      font-size: 24px;
      font-weight: 200;
      cursor: pointer;
      user-select: none;
      flex: 1 1;
      text-align: center;
    }
    .cnt {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1 1;
      text-align: center;
    }
  }
  .billed-amount-holder {
    font-size: 20px;
    background: #f6faff;
    border-radius: 10px;
    .billing-wrapper {
      padding: 20px 0;
      display: flex;
    }
    .left-billing-section {
      width: 60%;
      text-align: right;
      padding-right: 30px;
    }
    .right-billing-section {
      width: 15%;
      text-align: end;
    }
  }
  .payment-holder {
    justify-content: flex-end;
    display: flex;
  }
`;

const NumberHolder = styled.div`
  background: ${(props) => (props.highlight ? 'lightyellow' : 'none')};
  .action-btn-disabled {
    opacity: 0.3;
    cursor: not-allowed !important;
  }
`;

const PlanItemContainer = (props) => {
  const {
    selectedPlan,
    handleManageModal = () => {},
    showManageButton = false,
    type,
    decrementHandler,
    incrementHandler,
    tenure,
    currency,
    locale,
    planEstimate,
    addon,
    includeAddon,
    licenseCount,
    minimumLicenseCount,
    actualLicenseCount,
    isAddon = false,
    monitorCount = null
  } = props;

  const onAdd = () => {
    return (
      !(selectedPlan?.chargeBeePlanId === 'solo' && !isAddon) &&
      incrementHandler(type)
    );
  };

  const onMinus = () => {
    if (
      licenseCount[type] === 0 ||
      minimumLicenseCount[type] === licenseCount[type]
    ) {
      return;
    }
    if (!(selectedPlan?.chargeBeePlanId === 'solo' && !isAddon)) {
      decrementHandler(type);
    }
  };

  return (
    <>
      <div className="mt20">
        {isAddon && (
          <div className="mb5">
            <Badge status="info">
              <FormattedMessage id="common.label.addon.pack" />
            </Badge>
          </div>
        )}
        <PlanItemContainerWrapper className="flex actr">
          <div className="plan-type">
            <TextStyle variation="strong">
              <FormattedMessage
                id={
                  TITLE_MAP[addon?.addon?.offeringEntityType] ||
                  'Technician License'
                }
              />
            </TextStyle>
            {includeAddon && (
              <div className="desc italic">
                <TextStyle variation="subdued">
                  {`${addon?.addon?.countPerLicense || 150} ${
                    type === 'TECHNICIAN'
                      ? 'end points per technician'
                      : 'per pack'
                  }`}
                </TextStyle>
              </div>
            )}
          </div>
          <div
            className={
              selectedPlan?.chargeBeePlanId === 'solo' && type === 'TECHNICIAN'
                ? `plan-inp opacity`
                : 'plan-inp'
            }
          >
            <NumberHolder
              className="flex number-holder"
              highlight={licenseCount[type] > actualLicenseCount[type]}
            >
              <div
                className={
                  minimumLicenseCount[type] === licenseCount[type]
                    ? 'action-btn action-btn-disabled'
                    : 'action-btn'
                }
                onClick={onMinus}
              >
                -
              </div>
              <div className="cnt">{licenseCount[type]}</div>
              <div className="action-btn" onClick={onAdd}>
                +
              </div>
            </NumberHolder>
          </div>
          <div className="desc italic plan-calc">
            <TextStyle variation="subdued">
              {licenseCount[type]} x{' '}
              {locale &&
                currency &&
                tenure &&
                new Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency,
                  minimumFractionDigits: 0,
                  currencyDisplay: 'narrowSymbol'
                }).format(
                  type === 'TECHNICIAN'
                    ? planEstimate?.plan?.unitPrice
                    : addon?.unitPrice
                )}
            </TextStyle>
          </div>
          <div className="plan-total">
            <TextStyle variation="strong">
              {locale &&
                currency &&
                tenure &&
                new Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency,
                  minimumFractionDigits: 2,
                  currencyDisplay: 'narrowSymbol'
                }).format(
                  type === 'TECHNICIAN'
                    ? planEstimate?.plan?.amount
                    : addon?.amount
                )}
            </TextStyle>
          </div>
          <div className="desc italic plan-total-desc">
            {!!licenseCount[type] && selectedPlan?.endPointsCount
              ? `manage ${(addon?.addon?.countPerLicense || 150) *
                  licenseCount[type]} endpoints`
              : ''}
          </div>
        </PlanItemContainerWrapper>
        <div className="gap-20">
          {isAddon && showManageButton && monitorCount?.available ? (
            <>
              <TextStyle weight="Bold">
                {`${monitorCount?.available} assets already monitoring`}
              </TextStyle>
            </>
          ) : (
            <></>
          )}
          {showManageButton && (
            <div className="fx modify-btn actr jctr">
              <Button
                plain
                onClick={() =>
                  handleManageModal(
                    isAddon ? addon?.addon?.offeringEntityType : type
                  )
                }
              >
                modify
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default withRouter(PlanItemContainer);
